module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight-9089286e6a386b872d58b366bd56fd2b.png";